import React, {useContext} from 'react';
import {ConfigContext} from 'portal-core/components/PortalApp';
import {Workflow} from 'portal-core/components/Workflow';
import {
  ApplicationActionsContext,
  ProductInfoContext
} from 'portal-core/components/data/ApplicationDataSource';
import Alert from 'antd/lib/alert';
import {Summary} from 'portal-core/components/Summary';
import {ModelContext} from "../../modules/portal-core/components/metadata/ModelSource";

export function ApplicationWorkflowSwitch() {

  const applicationModel = useContext(ModelContext);
  const {productId} = useContext(ProductInfoContext);
  const {productSetup} = useContext(ProductInfoContext);
  const {saveApplication} = useContext(ApplicationActionsContext);

  const config = useContext(ConfigContext);

  let workflowType = applicationModel.data.typeCd || 'QuickQuote';

  if (productSetup.quickQuoteEnabledInd) {
    if (workflowType === 'Application') {
      workflowType = 'Quote';
    }
  }


  let productWorkflows = config.workflows[productId];
  if (productWorkflows) {
    const workflow = productWorkflows[workflowType];
    if (workflow) {
      return <React.Fragment>

        <Workflow lineCd={config.workflows.lineCd} riskTypeCd={config.workflows.riskTypeCd} {...workflow} onMove={saveApplication}>

        </Workflow>
      </React.Fragment>
    }
  }

  return null;
}